import { ReactNode, useState, useContext, createContext } from 'react';
import { MfaSetupGuardSync } from './components/MfaSetupGuardSync';

interface MfaCredentials {
  username: string;
  password: string;
}

interface MfaContextType {
  tempCredentials: MfaCredentials | null;
  setTempCredentials: (creds: MfaCredentials | null) => void;
  authEmail: string | null;
  setAuthEmail: (email: string | null) => void;
  organizationMfaEnabled: boolean;
  setOrganizationMfaEnabled: (enabled: boolean) => void;
  mfaVerificationMode: 'phone-setup' | null;
  setMfaVerificationMode: (mode: 'phone-setup' | null) => void;
}

const MfaContext = createContext<MfaContextType | undefined>(undefined);

export const MfaProvider = ({ children }: { children: ReactNode }) => {
  const [tempCredentials, setTempCredentials] = useState<MfaCredentials | null>(
    null,
  );
  const [authEmail, setAuthEmail] = useState<string | null>(null);
  const [organizationMfaEnabled, setOrganizationMfaEnabled] = useState(false);
  const [mfaVerificationMode, setMfaVerificationMode] = useState<
    'phone-setup' | null
  >(null);

  return (
    <MfaContext.Provider
      value={{
        tempCredentials,
        setTempCredentials,
        authEmail,
        setAuthEmail,
        organizationMfaEnabled,
        setOrganizationMfaEnabled,
        mfaVerificationMode,
        setMfaVerificationMode,
      }}
    >
      <MfaSetupGuardSync />
      {children}
    </MfaContext.Provider>
  );
};

export const useMfa = () => {
  const context = useContext(MfaContext);
  if (context === undefined) {
    throw new Error('useMfa must be used within a MfaProvider');
  }
  return context;
};
